var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('vue-confirm-dialog'),_c('router-view',{key:_vm.$route.path}),_c('upload-file-popup'),_c('confirm-popup'),_c('notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }